// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.btn-primary-normal[data-v-5ec83d69] {\n  padding-top: 0.68rem;\n  padding-bottom: 0.68rem;\n}\n.search-input-base[data-v-5ec83d69] {\n  min-width: 250px;\n}\n", ""]);
// Exports
module.exports = exports;
